import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';

export class TaxjarOverlayBloc extends BaseBloc {
  private readonly integrationBloc = resolve(Blocs.integration);
  private readonly dealBoardBloc = resolve(Blocs.dealBoard);

  createIntegration = this.integrationBloc.createIntegration;
  loading = new LoadingState();

  deals$ = this.dealBoardBloc.boards$;

  onInit() {
    return this.dealBoardBloc.fetchDealBoards();
  }
}
